<template>
  <div class="shop-sign-in-page" data-test="shop-sign-in__page">
    <Card class="shop-sign-in-card">
      <div class="shop-sign-in-card__header">
        <span class="shop-sign-in-title">{{ $t('shopSignInPage.title') }}</span>
        <HSpacer size="s"/>
        <ShopSignInForm />
      </div>
    </Card>
  </div>
</template>

<script>
import Card from '@/components/Card/Card.vue';
import HSpacer from '@/components/Divider/HSpacer.vue';
import ShopSignInForm from '@/views/pages/ShopSignInPage/ShopSignInForm.vue';

export default {
  components: {
    Card,
    HSpacer,
    ShopSignInForm,
  },
  methods: {
    onSignIn() {
      // Do Something
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '../../../assets/css/main.styl';

.shop-sign-in-page {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.shop-sign-in-card {
  width: 240px;
  padding: 40px 32px;
}
.shop-sign-in-card__header {
  text-align: center;
}
.shop-sign-in-title {
  color: $primary-color;
  position: relative;
  font-size: 1.5rem;
  font-weight: 600;
  text-align: center;
  display: inline;
}

// iPad Portrait
@media only screen and (min-width: 48rem) {
  .shop-sign-in-card {
    width: 18rem;
  }
}
//iPad Landscape + desktop
@media only screen and (min-width: 64rem) {
}
//Desktop petit + hd desktop
@media only screen and (min-width: 80rem) {
}
</style>
